import { render } from "./AppMobile.vue?vue&type=template&id=c190e760&scoped=true"
import script from "./AppMobile.vue?vue&type=script&lang=js"
export * from "./AppMobile.vue?vue&type=script&lang=js"

import "./AppMobile.vue?vue&type=style&index=0&id=c190e760&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c190e760"

export default script